import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import Method from "./components/Method";
import Plans from "./components/Plans";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import BeforeAfter from "./components/BeforeAfter";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LeadsAdmin from "./pages/LeadsAdmin";
import { initLenis, destroyLenis } from "./lib/scroll";
import "./App.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black font-body text-white grid place-items-center">
          <p>Algo deu errado. Recarregue a página.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Method />
      <Plans />
      <About />
      <Testimonials />
      <BeforeAfter />
      <Faq />
      <Contact />
    </main>
    <Footer />
  </>
);

export default function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="relative z-[1]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<LeadsAdmin />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </div>
      </BrowserRouter>
      <div className="rain-layer" aria-hidden="true" />
      <div className="grain-overlay" aria-hidden="true" />
    </ErrorBoundary>
  );
}
